import { Statistic } from 'antd';

const GenericStatistics: React.FC<any> = ({ ...props }) => {
  return <Statistic {...props} />;
};

export default GenericStatistics;
